import { useMutation } from "@tanstack/react-query";

import { addPlatformTermsConsent } from "services";

import { ADD_PLATFORM_TERMS_CONSENT } from "consts";

export const useAddPlatformTermsConsent = ({ accepted }: { accepted?: boolean }) =>
  useMutation({
    mutationKey: [ADD_PLATFORM_TERMS_CONSENT],
    mutationFn: () => addPlatformTermsConsent({ accepted }),
  });
